module.exports = __webpack_public_path__ + "static/img/icon-uncheck.7dd03143.svg";